import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    ${device.less1180} {
        gap: 10px;
    }
`;

export const Head = styled.div`
    display: flex;
    gap: 5px 25px;
    flex-wrap: wrap;
    
    ${device.less1180} {
        gap: 0 25px;
    }
`;

export const Body = styled.div``;
export const Foot = styled.div`
    height: 0;
    opacity: 0.0001;
    pointer-events: none;
    position: fixed; 
    left: 0;
    bottom: 0;
`;
